import { cloneDeep } from "lodash";
import { dateRangeFilterOptions, defaultSelectedFilters } from "../../consts";

const SET_PERIOD = "app/dashboardFilters/SET_PERIOD";
const SET_APP_TYPE = "app/dashboardFilters/SET_APP_TYPE";
const SET_DATES_RANGE = "app/dashboardFilters/SET_DATES_RANGE";
const SET_DEVICE = "app/dashboardFilters/SET_DEVICE";
const SET_MARKET = "app/dashboardFilters/SET_MARKET";
const SET_LOCATION = "app/dashboardFilters/SET_LOCATION";
const SET_PLATFORM = "app/dashboardFilters/SET_PLATFORM";
const SET_BROWSER = "app/dashboardFilters/SET_BROWSER";
const SET_GROUP = "app/dashboardFilters/SET_GROUP";
const SET_CONNECTIVITY = "app/dashboardFilters/SET_CONNECTIVITY";
const SET_IS_FILTERS_CHANGED = "app/dashboardFilters/SET_IS_FILTERS_CHANGED";

// Default filters
const SET_SELECTED_PERIOD = "app/dashboardFilters/SET_SELECTED_PERIOD";
const SET_SELECTED_APP_TYPE = "app/dashboardFilters/SET_SELECTED_APP_TYPE";
const SET_SELECTED_FROM_DATE = "app/dashboardFilters/SET_SELECTED_FROM_DATE";
const SET_SELECTED_TO_DATE = "app/dashboardFilters/SET_SELECTED_TO_DATE";
const SET_SELECTED_DEVICE = "app/dashboardFilters/SET_SELECTED_DEVICE";
const SET_LOCATION_OPTIONS = "app/dashboardFilters/SET_LOCATION_OPTIONS";
const SET_SELECTED_MARKET = "app/dashboardFilters/SET_SELECTED_MARKET";
const SET_SELECTED_LOCATION = "app/dashboardFilters/SET_SELECTED_LOCATION";
const SET_SELECTED_PLATFORM = "app/dashboardFilters/SET_SELECTED_PLATFORM";
const SET_SELECTED_BROWSER = "app/dashboardFilters/SET_SELECTED_BROWSER";
const SET_SELECTED_GROUP = "app/dashboardFilters/SET_SELECTED_GROUP";
const SET_SELECTED_CONNECTIVITY = "app/dashboardFilters/SET_SELECTED_CONNECTIVITY";

const SET_IS_FILTERS_SET = "app/dashboardFilters/SET_IS_FILTERS_SET";
const SET_IS_DASHBOARDS_FILTER_APP_CHANGED =
  "app/dashboardFilters/SET_IS_DASHBOARDS_FILTER_APP_CHANGED";
const RESET_SELECTED_FILTERS = "app/dashboardFilters/RESET_SELECTED_FILTERS";
const RESET_APPLIED_FILTERS = "app/dashboardFilters/RESET_APPLIED_FILTERS";

const initialState = {
  selectedFilters: { ...defaultSelectedFilters },
  isFiltersSet: false,
  isFiltersChanged: false,
  isDashboardAppFilterChanged: false,
  period: dateRangeFilterOptions.THIS_WEEK,
  appType: null,
  fromDate: null,
  toDate: null,
  device: null,
  market: null,
  location: null,
  platform: null,
  browser: null,
  group: null,
  connectivity: null
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_SELECTED_PERIOD: {
      const clonedState = cloneDeep(state);

      const newSelectedFilters = {
        ...clonedState.selectedFilters,
        selectedPeriod: action.payload
      };

      return {
        ...clonedState,
        selectedFilters: newSelectedFilters
      };
    }

    case SET_SELECTED_APP_TYPE: {
      const clonedState = cloneDeep(state);

      const newSelectedFilters = {
        ...clonedState.selectedFilters,
        selectedAppType: action.payload
      };

      return {
        ...clonedState,
        selectedFilters: newSelectedFilters
      };
    }

    case SET_SELECTED_FROM_DATE: {
      const clonedState = cloneDeep(state);

      const newSelectedFilters = {
        ...clonedState.selectedFilters,
        selectedFromDate: action.payload
      };

      return {
        ...clonedState,
        selectedFilters: newSelectedFilters
      };
    }

    case SET_SELECTED_TO_DATE: {
      const clonedState = cloneDeep(state);

      const newSelectedFilters = {
        ...clonedState.selectedFilters,
        selectedToDate: action.payload
      };

      return {
        ...clonedState,
        selectedFilters: newSelectedFilters
      };
    }

    case SET_SELECTED_DEVICE: {
      const clonedState = cloneDeep(state);

      const newSelectedFilters = {
        ...clonedState.selectedFilters,
        selectedDevice: action.payload
      };

      return {
        ...clonedState,
        selectedFilters: newSelectedFilters
      };
    }

    case SET_LOCATION_OPTIONS: {
      const clonedState = cloneDeep(state);

      const newSelectedFilters = {
        ...clonedState.selectedFilters,
        locationOptions: [...action.payload]
      };

      return {
        ...clonedState,
        selectedFilters: newSelectedFilters
      };
    }

    case SET_SELECTED_MARKET: {
      const clonedState = cloneDeep(state);

      const newSelectedFilters = {
        ...clonedState.selectedFilters,
        selectedMarket: action.payload
      };

      return {
        ...clonedState,
        selectedFilters: newSelectedFilters
      };
    }

    case SET_SELECTED_LOCATION: {
      const clonedState = cloneDeep(state);

      const newSelectedFilters = {
        ...clonedState.selectedFilters,
        selectedLocation: action.payload
      };

      return {
        ...clonedState,
        selectedFilters: newSelectedFilters
      };
    }

    case SET_SELECTED_PLATFORM: {
      const clonedState = cloneDeep(state);

      const newSelectedFilters = {
        ...clonedState.selectedFilters,
        selectedPlatform: action.payload
      };

      return {
        ...clonedState,
        selectedFilters: newSelectedFilters
      };
    }

    case SET_SELECTED_BROWSER: {
      const clonedState = cloneDeep(state);

      const newSelectedFilters = {
        ...clonedState.selectedFilters,
        selectedBrowser: action.payload
      };

      return {
        ...clonedState,
        selectedFilters: newSelectedFilters
      };
    }

    case SET_SELECTED_GROUP: {
      const clonedState = cloneDeep(state);

      const newSelectedFilters = {
        ...clonedState.selectedFilters,
        selectedGroup: action.payload
      };

      return {
        ...clonedState,
        selectedFilters: newSelectedFilters
      };
    }

    case SET_SELECTED_CONNECTIVITY: {
      const clonedState = cloneDeep(state);

      const newSelectedFilters = {
        ...clonedState.selectedFilters,
        selectedConnectivity: action.payload
      };

      return {
        ...clonedState,
        selectedFilters: newSelectedFilters
      };
    }

    case SET_IS_FILTERS_SET: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        isFiltersSet: action.payload
      };
    }

    case SET_IS_FILTERS_CHANGED: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        isFiltersChanged: action.payload
      };
    }

    case SET_IS_DASHBOARDS_FILTER_APP_CHANGED: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        isDashboardAppFilterChanged: action.payload
      };
    }

    case RESET_SELECTED_FILTERS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        selectedFilters: { ...defaultSelectedFilters },
        isFiltersSet: false
      };
    }

    case RESET_APPLIED_FILTERS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        period: dateRangeFilterOptions.THIS_WEEK,
        fromDate: null,
        toDate: null,
        device: null,
        market: null,
        location: null,
        platform: null,
        browser: null,
        appType: null,
        group: null,
        connectivity: null
      };
    }

    case SET_PERIOD: {
      const clonedState = cloneDeep(state);

      return { ...clonedState, period: action.payload };
    }

    case SET_APP_TYPE: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        appType: action.payload
      };
    }

    case SET_DATES_RANGE: {
      const clonedState = cloneDeep(state);

      return { ...clonedState, fromDate: action.payload.fromDate, toDate: action.payload.toDate };
    }

    case SET_DEVICE: {
      const clonedState = cloneDeep(state);

      return { ...clonedState, device: action.payload };
    }

    case SET_PLATFORM: {
      const clonedState = cloneDeep(state);

      return { ...clonedState, platform: action.payload };
    }

    case SET_MARKET: {
      const clonedState = cloneDeep(state);

      return { ...clonedState, market: action.payload };
    }

    case SET_LOCATION: {
      const clonedState = cloneDeep(state);

      return { ...clonedState, location: action.payload };
    }

    case SET_BROWSER: {
      const clonedState = cloneDeep(state);

      return { ...clonedState, browser: action.payload };
    }

    case SET_GROUP: {
      const clonedState = cloneDeep(state);

      return { ...clonedState, group: action.payload };
    }

    case SET_CONNECTIVITY: {
      const clonedState = cloneDeep(state);

      return { ...clonedState, connectivity: action.payload };
    }

    default:
      return state;
  }
}

export const setPeriod = (period) => ({
  type: SET_PERIOD,
  payload: period
});

export const setAppType = (appType) => ({ type: SET_APP_TYPE, payload: appType });

export const setDatesRange = (fromDate, toDate) => ({
  type: SET_DATES_RANGE,
  payload: { fromDate, toDate }
});

export const setDevice = (device) => ({ type: SET_DEVICE, payload: device });

export const setMarket = (market) => ({ type: SET_MARKET, payload: market });

export const setLocation = (location) => ({ type: SET_LOCATION, payload: location });

export const setPlatform = (platform) => ({ type: SET_PLATFORM, payload: platform });

export const setBrowser = (browser) => ({ type: SET_BROWSER, payload: browser });

export const setGroup = (group) => ({ type: SET_GROUP, payload: group });

export const setConnectivity = (connectivity) => ({
  type: SET_CONNECTIVITY,
  payload: connectivity
});

export const setSelectedPeriod = (period) => ({
  type: SET_SELECTED_PERIOD,
  payload: period
});

export const setSelectedAppType = (appType) => ({ type: SET_SELECTED_APP_TYPE, payload: appType });

export const setSelectedFromDate = (fromDate) => ({
  type: SET_SELECTED_FROM_DATE,
  payload: fromDate
});

export const setSelectedToDate = (toDate) => ({
  type: SET_SELECTED_TO_DATE,
  payload: toDate
});

export const setSelectedDevice = (device) => ({
  type: SET_SELECTED_DEVICE,
  payload: device
});

export const setLocationOptions = (options) => ({
  type: SET_LOCATION_OPTIONS,
  payload: options
});

export const setSelectedMarket = (market) => ({
  type: SET_SELECTED_MARKET,
  payload: market
});

export const setSelectedLocation = (location) => ({
  type: SET_SELECTED_LOCATION,
  payload: location
});

export const setSelectedPlatform = (selectedPlatform) => ({
  type: SET_SELECTED_PLATFORM,
  payload: selectedPlatform
});

export const setSelectedBrowser = (selectedBrowser) => ({
  type: SET_SELECTED_BROWSER,
  payload: selectedBrowser
});

export const setSelectedGroup = (selectedGroup) => ({
  type: SET_SELECTED_GROUP,
  payload: selectedGroup
});

export const setSelectedConnectivity = (selectedConnectivity) => ({
  type: SET_SELECTED_CONNECTIVITY,
  payload: selectedConnectivity
});

export const setIsFiltersSet = (isFiltersSet) => ({
  type: SET_IS_FILTERS_SET,
  payload: isFiltersSet
});

export const setIsFiltersChanged = (isFiltersChanged) => ({
  type: SET_IS_FILTERS_CHANGED,
  payload: isFiltersChanged
});

export const setIsDashboardFilterAppChanged = (isDashboardFilterAppChanged) => ({
  type: SET_IS_DASHBOARDS_FILTER_APP_CHANGED,
  payload: isDashboardFilterAppChanged
});

export const resetSelectedFilters = () => ({ type: RESET_SELECTED_FILTERS });

export const resetAppliedFilters = () => ({ type: RESET_APPLIED_FILTERS });
